module.exports = __webpack_public_path__ + "media/images/wjc-logo-vertical-white-65a67d47dc2d83c9d136a8a311d32010.svg";